/// <amd-module name="VSS/Features/AvatarImagePicker/AvatarImagePicker" />
export * from "./Components/AvatarImagePicker/AvatarImagePicker";
export { IAvatarImagePickerProps, ImageData, InputFileSelect } from "./Components/AvatarImagePicker/AvatarImagePicker.Props";
export * from "./Components/FilePicker/FilePickerInput";
export { IFilePickerInputProps } from "./Components/FilePicker/FilePickerInput.Props";
